export const INQUIRY_AUCTION_CREATE_PAGE_PATH = '/auction/inquiry/create'
